import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	learnMore: {
		id: 'spa-apps-sidebar-next-gen.menu.footer.learn-more',
		defaultMessage: 'Learn more',
		description: 'Link that opens a help article on next-gen projects.',
	},
	learnMoreAriaLabel: {
		id: 'spa-apps-sidebar-next-gen.menu.footer.learn-more-aria-label',
		defaultMessage: 'Learn more about team-managed projects',
		description:
			'Descriptive hidden label for the link that opens a help article on next-gen projects.',
	},
	// Rebranded
	titleTeamManaged: {
		id: 'spa-apps-sidebar-next-gen.menu.footer.title-team-managed',
		defaultMessage: "You're in a team-managed project",
		description: 'This is what the user sees when they are on a next-gen project',
	},
});
